import { ca } from '@cian/analytics';
import { TAnalyticsSiteType } from '../../types/analytics';

interface ITrackProps {
  dealType: string;
  category: string | null;
  offerId: number | null;
  userId: number | undefined;
  siteType: TAnalyticsSiteType;
}

export const trackShowDemandTrap = ({ dealType, category, offerId, userId, siteType }: ITrackProps) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Show',
    label: `${dealType}/${category}/${offerId}`,
    user: {
      userId,
    },
    products: [
      {
        id: offerId,
      },
    ],
    page: {
      pageType: 'AddForm',
      siteType,
      extra: {
        category,
        banner_location: 'New_ad',
      },
    },
  });
};

export const trackClickButtonDemandTrap = ({ dealType, category, offerId, userId, siteType }: ITrackProps) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Click',
    label: `${dealType}/${category}/${offerId}`,
    user: {
      userId,
    },
    products: [
      {
        id: offerId,
      },
    ],
    page: {
      pageType: 'AddForm',
      siteType,
      extra: {
        category,
        banner_location: 'New_ad',
      },
    },
  });
};

export const trackSuccessCreatedMessage = ({ dealType, category, offerId, userId, siteType }: ITrackProps) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Send_application_sopr',
    label: `${dealType}/${category}/${offerId}`,
    user: {
      userId,
    },
    products: [
      {
        id: offerId,
      },
    ],
    page: {
      pageType: 'AddForm',
      siteType,
      extra: {
        category,
        banner_location: 'New_ad',
      },
    },
  });
};

export const trackShowRosbankPilotBanner = ({ offerId, category }: Partial<ITrackProps>) => {
  ca('eventSite', {
    action: 'show_sopr',
    category: 'Alternative',
    label: 'Banner',
    name: 'oldevent',
    page: {
      extra: {
        banner_location: 'New_ad',
        category,
      },
    },
    products: [
      {
        id: offerId,
        offerType: 'offer',
      },
    ],
  });
};

export const trackClickRosbankPilotBanner = ({ offerId, category }: Partial<ITrackProps>) => {
  ca('eventSite', {
    action: 'click_sopr',
    category: 'Alternative',
    label: 'Banner',
    name: 'oldevent',
    page: {
      extra: {
        banner_location: 'New_ad',
        category,
      },
    },
    products: [
      {
        id: offerId,
        offerType: 'offer',
      },
    ],
  });
};
